export default [

    {
        url: null,
        name: "Cockpit Dashboard",
        slug: null,
        permission: null,
        icon: "PieChartIcon",
        submenu: []
    },

    {
        url: null,
        name: "Reporting by Week",
        slug: null,
        permission: null,
        icon: "ZapIcon",
        submenu: []
    },

    {
        url: null,
        name: "Reporting by Month",
        slug: null,
        permission: null,
        icon: "TrendingUpIcon",
        submenu: []
    },
    {
        url: null,
        name: "Reporting by Year",
        slug: null,
        permission: null,
        icon: "BarChart2Icon",
        submenu: []
    },
    {
        url: null,
        name: "Budgets",
        slug: null,
        permission: null,
        icon: "CalendarIcon",
        submenu: []
    },
    {
        url: null,
        name: "Campus",
        slug: null,
        permission: null,
        icon: "UsersIcon",
        submenu: []
    },

    {
        url: "/cp/powerbitester",
        name: "PowerBI Tester",
        slug: "powerbiTester",
        permission: null,
        icon: "AlertCircleIcon",
    },


];
